import React from "react";
import styles from "./index.module.css";
import NoResultsFoundImg from "../../assets/images/icons/no_data_no result@3x.png";

const NoResultsFound = () => {
  return (
    <div className={styles.noResults}>
      <img
        src={NoResultsFoundImg}
        alt="No Results Found"
        className={styles.noResultsImage}
      />
      <p>No Results Found</p>
    </div>
  );
};

export default NoResultsFound;
